<div class="container">
  <div class="row">
    <div class="col-md-12 px-3">
      <br />
      <h1>{{'TURNOVER_STATISTICS' | translate}}</h1>
      @if (companies && companies.length) {
        <div class="row">
          @for (company of companies; track company) {
            <!-- WS -->
            @if (company.companyID === 'WS') {
              <div class="col-12 col-sm-6">
                <h2>Winora-Staiger</h2>
                <div class="d-block mb-2">
                  <button class="btn btn-dark mb-3" (click)="downloadPdf('WS')">{{'DOWNLOAD_PDF' | translate}}</button>
                </div>
                <div class="d-flex w-100">
                  @if (company.fileURL) {
                    <pdf-viewer [src]="company.fileURL" class="border border-dark w-100"
                      [original-size]="false"
                      [autoresize]="true"
                      [fit-to-page]="false"
                    > </pdf-viewer>
                  }
                </div>
              </div>
            }
            <!-- WBP -->
            @if (company.companyID === 'WBP') {
              <div class="col-12 col-sm-6">
                <h2>E. Wiener Bike Parts </h2>
                <div class="d-block mb-2">
                  <button class="btn btn-dark mb-3" (click)="downloadPdf('WBP')">{{'DOWNLOAD_PDF' | translate}}</button>
                </div>
                <div class="d-flex w-100">
                  @if (company.fileURL) {
                    <pdf-viewer [src]="company.fileURL" class="border border-dark w-100"
                      [original-size]="false"
                      [autoresize]="true"
                      [fit-to-page]="false"
                    > </pdf-viewer>
                  }
                </div>
              </div>
            }
          }
        </div>
      } @else {
        {{ 'NO_RESULTS' | translate }}
      }
    </div>
  </div>
</div>
